import { render, staticRenderFns } from "./ConfirmDeleteMerchant.vue?vue&type=template&id=2b28447f"
import script from "./ConfirmDeleteMerchant.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteMerchant.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteMerchant.vue?vue&type=style&index=0&id=2b28447f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports